import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme: MuiTheme) => ({
  root: {
    width: "auto",
    background: "#fff",
    padding: 0
  },
  searchResult: {
    width: "100%",
    marginTop: 8,
    [theme.breakpoints.down("xs")]: {
      marginTop: 0
    }
  },
  gridRoot: {
    padding: "7px 24px",
    [theme.breakpoints.down("sm")]: {
      padding: "4px 24px 16px"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "16px"
    }
  },
  gridItem: {
    "& > .MuiGrid-item": {
      [theme.breakpoints.down("xs")]: {
        paddingTop: 0,
        paddingBottom: 10
      }
    }
  },
  gridItemScrollable: {
    overflow: "auto"
  },
  itemIcon: {
    minWidth: "32px"
  },
  itemIconHorse: {
    width: "16px",
    height: "16px",
    marginLeft: "1px",
    fill: theme.palette.primary.light
  },
  itemText: {},
  weather: {
    marginTop: 16
  },
  appSearchCell: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      justifyContent: "center"
    }
  },
  appSearch: {
    [theme.breakpoints.up("md")]: {
      maxWidth: 400,
      width: "100%"
    }
  }
}));
